 function copyCouponCode() {
  copyToClipboard("couponCode");
}

function copyToClipboard(elementId) {
  // 创建一个临时输入框元素
  var tempInput = document.createElement("input");
  
  // 获取要复制的文本
  var textToCopy = document.getElementById(elementId).value;
  
  // 将文本设置为临时输入框的值
  tempInput.value = textToCopy;
  
  // 将临时输入框添加到页面中
  document.body.appendChild(tempInput);
  
  // 选择临时输入框中的文本
  tempInput.select();
  tempInput.setSelectionRange(0, 99999); // 兼容部分移动端浏览器
  
  // 复制文本
  document.execCommand("copy");
  
  // 从页面中移除临时输入框
  document.body.removeChild(tempInput);

  // 复制成功后将按钮文本改为 "copied"，添加优惠券样式
  var button = document.getElementById("copyCouponButton");
  button.textContent = "Copied";
  button.classList.add("copied");

  // 两秒后恢复按钮文本为 "复制优惠码"，移除优惠券样式
  setTimeout(function() {
    button.textContent = "Copy";
    button.classList.remove("Copied");
  }, 2000);
}